export default {
  description: {
    type: 'string',
    required: true,
  },
};
